// import React from "react";
// import { motion } from "framer-motion";

// import '../Scc/About.scss'

// const About = () => {
//   return (
//     <div className="max-w-5xl mx-auto p-6 bg-white shadow-xl rounded-lg mt-6">
//       <header className="text-center border-b-2 border-gray-200 pb-4">
//         <motion.h1
//           className="text-4xl font-bold text-blue-700"
//           initial={{ x: -100, opacity: 0 }}
//           animate={{ x: 0, opacity: 1 }}
//           transition={{ type: "spring", stiffness: 120 }}
//         >
//           About MBJ Tech
//         </motion.h1>
//         <p className="text-gray-500 text-lg mt-2">
//           Precision. Innovation. Excellence.
//         </p>
//       </header>

//       <section className="mt-6 text-gray-700 text-lg leading-relaxed">
//         <p>
//           At MBJ Tech, we are committed to delivering top-tier industrial
//           solutions that embody precision, innovation, and excellence. Based in
//           Pune, Maharashtra, we specialize in a comprehensive range of services,
//           including supply chain solutions, engraving, laser printing, CNC
//           machining, and VMC operations.
//         </p>
//       </section>

//       <section className="mt-8">
//         <h2 className="text-2xl font-semibold text-gray-800 mb-4">
//           Our Services
//         </h2>
//         <ul className="space-y-4">
//           {[
//             {
//               title: "Supply Solutions",
//               desc: "Efficient and reliable supply chain management to ensure timely delivery of materials and components.",
//             },
//             {
//               title: "Engraving & Laser Printing",
//               desc: "High-precision engraving and laser printing services for various materials, ensuring durability and clarity.",
//             },
//             {
//               title: "CNC Machining",
//               desc: "Advanced CNC machining services that provide accurate and consistent manufacturing of complex parts.",
//             },
//             {
//               title: "VMC Operations",
//               desc: "Vertical Machining Center services that offer high-speed and high-precision milling for intricate components.",
//             },
//           ].map(({ title, desc }, index) => (
//             <motion.li
//               key={index}
//               className="bg-gray-100 p-4 rounded-md shadow-sm"
//               whileHover={{ scale: 1.02 }}
//               transition={{ type: "spring", stiffness: 200 }}
//             >
//               <strong className="block text-gray-900 mb-2">{title}</strong>
//               {desc}
//             </motion.li>
//           ))}
//         </ul>
//       </section>

//       <section className="mt-8">
//         <h2 className="text-2xl font-semibold text-gray-800 mb-4">
//           Our Commitment
//         </h2>
//         <p className="text-gray-700 text-lg leading-relaxed">
//           At MBJ Tech, we prioritize quality and customer satisfaction. Our team
//           of skilled professionals leverages state-of-the-art technology to
//           deliver services that meet and exceed industry standards. We are
//           dedicated to continuous improvement and innovation, ensuring that our
//           clients receive the best possible solutions tailored to their specific
//           needs.
//         </p>
//       </section>

//       <section className="mt-8">
//         <h2 className="text-2xl font-semibold text-gray-800 mb-4">
//           Why Choose MBJ Tech?
//         </h2>
//         <ul className="space-y-4">
//           {[
//             {
//               title: "Expertise",
//               desc: "Years of experience in delivering high-quality industrial services.",
//             },
//             {
//               title: "Technology",
//               desc: "Utilization of cutting-edge machinery and software for optimal results.",
//             },
//             {
//               title: "Customer-Centric",
//               desc: "Focused on building long-term relationships through exceptional service and support.",
//             },
//             {
//               title: "Quality Assurance",
//               desc: "Strict adherence to quality control processes to ensure the highest standards.",
//             },
//           ].map(({ title, desc }, index) => (
//             <motion.li
//               key={index}
//               className="bg-gray-100 p-4 rounded-md shadow-sm"
//               whileHover={{ scale: 1.02 }}
//               transition={{ type: "spring", stiffness: 200 }}
//             >
//               <strong className="block text-gray-900 mb-2">{title}</strong>
//               {desc}
//             </motion.li>
//           ))}
//         </ul>
//       </section>

//       <footer className="text-center text-gray-500 text-sm mt-10 pt-4 border-t">
//         Partner with MBJ Tech for reliable and precise industrial solutions that
//         drive success.
//       </footer>
//     </div>
//   );
// };

// export default About;

import React from "react";
import { motion } from "framer-motion";
import '../Scc/About.scss';  // Import the SCSS file

const About = () => {
  return (
    <div className="about max-w-5xl mx-auto p-6 bg-white shadow-xl rounded-lg mt-6">
      <header className="text-center border-b-2 border-gray-200 pb-4">
        <motion.h1
          className="text-4xl font-bold text-blue-700"
          initial={{ x: -100, opacity: 0 }}
          animate={{ x: 0, opacity: 1 }}
          transition={{ type: "spring", stiffness: 120 }}
        >
          About MBJ Tech
        </motion.h1>
        <p className="text-gray-500 text-lg mt-2">
          Precision. Innovation. Excellence.
        </p>
      </header>

      <section className="mt-6 text-gray-700 text-lg leading-relaxed">
        <p>
          At MBJ Tech, we are committed to delivering top-tier industrial
          solutions that embody precision, innovation, and excellence. Based in
          Pune, Maharashtra, we specialize in a comprehensive range of services,
          including supply chain solutions, engraving, laser printing, CNC
          machining, and VMC operations.
        </p>
      </section>

      <section className="mt-8">
        <h2 className="text-2xl font-semibold text-gray-800 mb-4">
          Our Services
        </h2>
        <ul className="services-list space-y-4">
          {[
            {
              title: "Supply Solutions",
              desc: "Efficient and reliable supply chain management to ensure timely delivery of materials and components.",
            },
            {
              title: "Engraving & Laser Printing",
              desc: "High-precision engraving and laser printing services for various materials, ensuring durability and clarity.",
            },
            {
              title: "CNC Machining",
              desc: "Advanced CNC machining services that provide accurate and consistent manufacturing of complex parts.",
            },
            {
              title: "VMC Operations",
              desc: "Vertical Machining Center services that offer high-speed and high-precision milling for intricate components.",
            },
          ].map(({ title, desc }, index) => (
            <motion.li
              key={index}
              className="service bg-gray-100 p-4 rounded-md shadow-sm"
              whileHover={{ scale: 1.02 }}
              transition={{ type: "spring", stiffness: 200 }}
            >
              <strong className="block text-gray-900 mb-2">{title}</strong>
              {desc}
            </motion.li>
          ))}
        </ul>
      </section>

      <section className="mt-8">
        <h2 className="text-2xl font-semibold text-gray-800 mb-4">
          Our Commitment
        </h2>
        <p className="text-gray-700 text-lg leading-relaxed">
          At MBJ Tech, we prioritize quality and customer satisfaction. Our team
          of skilled professionals leverages state-of-the-art technology to
          deliver services that meet and exceed industry standards. We are
          dedicated to continuous improvement and innovation, ensuring that our
          clients receive the best possible solutions tailored to their specific
          needs.
        </p>
      </section>

      <section className="mt-8">
        <h2 className="text-2xl font-semibold text-gray-800 mb-4">
          Why Choose MBJ Tech?
        </h2>
        <ul className="why-choose-list space-y-4">
          {[
            {
              title: "Expertise",
              desc: "Years of experience in delivering high-quality industrial services.",
            },
            {
              title: "Technology",
              desc: "Utilization of cutting-edge machinery and software for optimal results.",
            },
            {
              title: "Customer-Centric",
              desc: "Focused on building long-term relationships through exceptional service and support.",
            },
            {
              title: "Quality Assurance",
              desc: "Strict adherence to quality control processes to ensure the highest standards.",
            },
          ].map(({ title, desc }, index) => (
            <motion.li
              key={index}
              className="why-choose bg-gray-100 p-4 rounded-md shadow-sm"
              whileHover={{ scale: 1.02 }}
              transition={{ type: "spring", stiffness: 200 }}
            >
              <strong className="block text-gray-900 mb-2">{title}</strong>
              {desc}
            </motion.li>
          ))}
        </ul>
      </section>

      <footer className="text-center text-gray-500 text-sm mt-10 pt-4 border-t">
        Partner with MBJ Tech for reliable and precise industrial solutions that
        drive success.
      </footer>
    </div>
  );
};

export default About;
